import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueContentPlaceholders from "vue-content-placeholders";
import vSelect from "vue-select";
import VueLazyLoad from "vue-lazyload";
import Sticky from "vue-sticky-directive";
import qs from "qs";
import TouchEvents from 'vue2-touch-events';
import router from "./router/router";
import App from "./App.vue";
import store from "./store/store";

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);
Vue.use(VueContentPlaceholders);
Vue.use(VueLazyLoad);
Vue.use(TouchEvents);
Vue.use(Sticky);

Vue.component("v-select", vSelect);

window.addEventListener("DOMContentLoaded", () => {
  let vuestore = document.getElementById('vue-store');
  if(vuestore){
    new Vue({
    router,
    store,
    render(h) {
      return h(App);
    },
    mounted() {
      const self = this;
      // const routeParams = self.$route.params;

      this.$store.commit('setNumberSeparator', ws_vue_store.number_separator);
      if (ws_vue_store.cart_item_packages) {
        this.$store.commit('setSelectedPackages', ws_vue_store.cart_item_packages);
      }

      /* Attributes */
      /*this.axios
        .get(ws_vue_store.attributes_endpoint + ws_vue_store.language_code)
        .then(response => {
          if (response.data) {
            self.$store.commit("setAttributeTaxonomies", response.data.data);
          }
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.error(err);
        });*/
      /*****************/

      this.axios
        .get(ws_vue_store.categories_endpoint + ws_vue_store.language_code)
        .then(response => {
          if (response.data.data) {
            self.$store.commit("setCategoryAllowedAttributes", Array.from(ws_vue_store.frontpage_attribute_order));
            self.$store.commit("setCategories", response.data.data);
            this.$store.dispatch("setFiltersFromUrl", []);

            if ( parseInt( ws_vue_store.unchecked_first_category_by_default )  !== 1 && !self.$store.state.filters.current.product_cat && !self.$store.getters.getSearchMode) {
              const firstTopCategory = self.$store.state.categories.find(
                category => category.parent === 0
              );
              if (firstTopCategory) {
                self.$store.commit("addFilter", {
                  taxonomy: "product_cat",
                  option: firstTopCategory ? firstTopCategory.term_id : undefined
                });
                self.$store.commit("updateCategoryPath");
              }
            }

            // If category is set then get category attributes for table columns
            if(self.$store.state.filters.current.product_cat){
              const setCategory = self.$store.state.filters.current.product_cat[0];
              const foundCategory = self.$store.state.categories.find(
                category => category.term_id == setCategory
              );
              if(foundCategory && foundCategory.store_attributes != undefined){
                self.$store.commit("setCategoryAllowedAttributes", foundCategory.store_attributes);
              }
            }

            self.$store.dispatch("getFilteredAttributes", [])
              .then(() => self.$store.dispatch("getProducts", []))
              .then(() => self.$store.commit("scrollToSavedPosition"));
          }
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.error(err);
        })
        .finally(() => {
          // self.$store.commit('changeLoadingState', false);
        });

      // If using browser back or forward button to go to previous filters
      window.onpopstate = (event) => {
        self.$store.commit('changeProductsLoadingState', true);

        self.$store.commit("clearFilters", {});
        self.$store.dispatch("setFiltersFromUrl", []);

        self.$store.dispatch("getFilteredAttributes", []).then(() => self.$store.dispatch("getProducts", []));
      };
    }
  }).$mount("#vue-store");
  }
});
